import { CreateElement } from 'vue'
import { RouteConfig } from 'vue-router'
import { CreateRouterOptions } from '@/typings/common'

import { lkPublicationPermissions as Permissions } from '@/helpers/enums/permission-models'
import * as TYPES from '@/helpers/enums/view-types'
import { MARKS_ROUTES as ROUTES } from './utils'


type Options = Required<CreateRouterOptions>
type PromiseVue = Promise<typeof import('*.vue')>

export { MENU as MENU_MARKS } from './utils'

const createRoutes = (options: Options): RouteConfig[] => [
  {
    path: 'marks',
    name: ROUTES.LAYOUT,
    redirect: { name: ROUTES.LIST },
    meta: { authorized: true },
    async beforeEnter(to, from, next) {
      const { registerModule, marksStoreModule } = await import(
        /* webpackChunkName: "marks.store" */
        './store'
      )
      registerModule(options)
      // Ужас
      const store = marksStoreModule.context(options.store)


      const promises = [
        store.actions.fetchSessions(),
        store.actions.fetchSubjects(),
        store.actions.fetchProcedures(),
      ]

      await Promise.all(promises)

      next()
    },
    component: {
      name: 'view-marks-layout',
      render: (h: CreateElement) => h('router-view'),
    },
    children: [
      {
        path: '',
        name: ROUTES.LIST,
        meta: {
          permission: Permissions.read,
        },
        component: (): PromiseVue => import(
          /* webpackChunkName: "marks.list" */
          './MarksList.vue'
        ),
      },
      // {
      //   path: ':id(\\d+)',
      //   name: ROUTES.VIEW,
      //   meta: {
      //     permission: Permissions.read,
      //   },
      //   props: ({ params: p }: Route) => ({ ...p, viewType: TYPES.VIEW }),
      //   component: (): PromiseVue => import(
      //     /* webpackChunkName: "publications.view" */
      //     './PublicationsView.vue'
      //   ),
      // },
      // {
      //   path: ':id(\\d+)/edit',
      //   name: ROUTES.EDIT,
      //   props: ({ params: p }: Route) => ({ ...p, viewType: TYPES.EDIT }),
      //   meta: {
      //     permission: Permissions.edit,
      //   },
      //   component: (): PromiseVue => import(
      //     /* webpackChunkName: "publications.view" */
      //     './PublicationsView.vue'
      //   ),
      // },
      {
        path: 'create',
        name: ROUTES.CREATE,
        props: () => ({ viewType: TYPES.CREATE }),
        meta: {
          permission: Permissions.create,
        },
        component: (): PromiseVue => import(
          /* webpackChunkName: "marks.view" */
          './MarksView.vue'
        ),
      },
      {
        path: 'upload',
        name: ROUTES.UPLOAD,
        component: (): PromiseVue => import(
          /* webpackChunkName: "marks.upload" */
          './MarksUploadView.vue'
        ),
      },
      {
        path: 'actions',
        name: ROUTES.ACTIONS,
        component: (): PromiseVue => import(
          /* webpackChunkName: "marks.actions" */
          './MarksJournalActionsView.vue'
        ),
      },
    ],
  },
]

const createModule = (options: Options) => {
  const routes = createRoutes(options)
  return routes
}

export default createModule
